/**
 * Display-name normalization for subscription plans.
 *
 * Post-pivot the UI sells exactly two tiers: Free and Premium. The live
 * Stripe products still carry the legacy tier names (Starter / Plus / Pro) —
 * `/api/stripe/plans` already DISPLAYS the borrowed paid price as "Premium"
 * ("rename Stripe later"), but `/api/balance` returns the raw Stripe product
 * name. Comparing the two by name made the Plans dialog show a Premium
 * subscriber as not-current ("Plus" !== "Premium"), and wallet surfaces
 * leaked the legacy name ("Plus · used first").
 *
 * Every ACTIVE paid subscription is Premium in the display model (this is
 * also what `workspaceLimitFor` assumes). Normalize at the display edge so
 * no Stripe edits are needed; when the Stripe products are renamed this
 * helper degrades to a pass-through.
 */
export function displayPlanName(planName: string | null | undefined): string | null {
  if (!planName) return null;
  const lower = planName.toLowerCase();
  if (lower === 'free') return 'Free';
  return 'Premium';
}
